import useHandleContextureBar from '@/hooks/useHandleContextureBar';
import contextualBarSlice, { isShowContextualBarSelector } from '@/redux/features/contextualBar.slice';
import { useDispatch, useSelector } from 'react-redux';
import { NavigateOptions, To, useNavigate } from 'react-router-dom';

interface IProps {
  forceNavigate?: boolean;
}

export default function useConfirmationNavigate({ forceNavigate }: IProps | undefined = {}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isShowContextualBar = useSelector(isShowContextualBarSelector);
  const contextualBar = useHandleContextureBar();
  return (to: To, options?: NavigateOptions) => {
    if (isShowContextualBar && !forceNavigate) {
      dispatch(
        contextualBarSlice.actions.handleConfirmNavigateState({
          isShowConfirmNavigate: true,
          to,
          options,
        }),
      );
    } else {
      navigate(to, options);
      contextualBar.hide();
    }
  };
}
